import React from 'react';
import { string, number, shape, arrayOf } from 'prop-types';
import { isEmpty, isFunction, get } from 'lodash';
import {
  makeStyles,
  TableContainer,
  Table as MuiTable,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Link,
} from '@material-ui/core';

import StatusContent from '../StatusContent';
import styles from './styles';

export const getColumns = ({ columns }) => (
  <TableRow>{
    columns.map(({ id, label, minWidth }) => (
      <TableCell style={{ minWidth }} key={id}>
        {label}
      </TableCell>
    ))
  }</TableRow>
);

export const getHyperlinkCellContent = ({ uuid, linkValue, format, value }) => (
  <Link underline="none" href={`${linkValue}/${uuid}`}>
    {format ? format(value) : value}
  </Link>
);

export const getPlainCellContent = ({ format, value, isStatusIcon, notifyMessages, message, id }) => {
   const content = format ? format(value) : value;
  return(
    isStatusIcon ?
      <StatusContent id={id} statusLabel={content} notifyMessages={notifyMessages} message={message} />
    :
    content
  );
};

export const getRows = ({ userContext, columns, rows, uuidName, notifyMessages }) => (
  rows.map(row => (
    <TableRow
      hover tabIndex={-1} key={row.uuid}
      onClick={() => {
        if (isFunction(row.onClick)) { row.onClick(row.uuid); }
      }}
    >
      {columns.map(column => {
        const { id, link, value, isStatusIcon } = column;
        const linkValue = link && isFunction(link) ? link({ ...row, userContext }) : link;
        const content = linkValue
          ? getHyperlinkCellContent({
            ...column,
            uuid: uuidName ? row[uuidName] :row.uuid,
            linkValue,
            value: value && isFunction(value) ? value(row) : row[id],
            uuidName,
          })
          : getPlainCellContent({
            ...column,
            value: value && isFunction(value) ? value(row) : row[id],
            isStatusIcon,
            notifyMessages,
            message: get(row, 'message'),
            id,
          });
        return (
          <TableCell key={id} align="left">
            {content}
          </TableCell>
        );
      })}
    </TableRow>
  ))
);

function Table(props) {
  const { userContext, id, noResultsMessage } = props;
  const useStyles = makeStyles(styles);
  const classes = useStyles();
  const columns = getColumns({ ...props });
  const rows = getRows({ ...props, userContext });

  return (
    <TableContainer
      className={classes.tableContainer}
      id={id} data-apim-test={id} data-layer7-test={id}
    >
      <MuiTable stickyHeader aria-label="sticky table">
        <TableHead>{columns}</TableHead>
        {isEmpty(rows) ?
          <caption>{noResultsMessage}</caption> :
          <TableBody>{rows}</TableBody>
        }
      </MuiTable>
    </TableContainer>
  );
}

export default Table;

getColumns.propTypes = {
  columns: arrayOf(shape({})),
};

getHyperlinkCellContent.propTypes = {
  uuid: string,
  linkValue: string,
  format: string,
  value: string || number,
};

getPlainCellContent.propTypes = {
  format: string, value: string || number,
};

Table.propTypes = {
  userContext: shape({}),
  id: string,
  noResultsMessage: string,
};



// WEBPACK FOOTER //
// ./src/components/Table/index.js